const CountDownCmpt = require("clover/panel/component/common/CountDownCmpt");

let TrinityGiftBagPanel = xClass("TrinityGiftBagPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/trinity_gift_trinity_gift_main.csb");
})

const RES = ["packed/TrinityGiftBagPanel.pack"];

TrinityGiftBagPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}

TrinityGiftBagPanel.prototype.ctor = function () {
    let self = this
    BasePanel.prototype.ctor.call(self);
    self.TrinityGiftBagMgr = TrinityGiftBagManager.getInstance();
    self.fitScreen();
    self.initUI();
    self.popup();
}

TrinityGiftBagPanel.prototype.initUI = function () {
    let self = this;
    //
    let top = self.getChildByName("top");
    let bottom = self.getChildByName("bottom");
    self.timeL = top.getChildByName("time").getChildByName("label_time");
    let com_close_red = top.getChildByName("com_close_red");
    let com_detail = top.getChildByName("com_detail");
    let dsct_label = bottom.getChildByName("com_dsct_1").getChildByName("label");
    //
    quickBuildUIButton(com_close_red, function () {
        if (self.isBusy) return;
        self.isBusy = true;
        self.onClose();
    });

    quickBuildUIButton(com_detail, () => {
        if (self.isBusy) return;
        self.isBusy = true;
        //
        ActivityCommon.showExplain(() => {
            //
            self.isBusy = false;
        }, {
            cHeight: 600,
            text: getText("trinity_gift_bag_description"),
            title: "玩法说明"
        })
    })
    //
    let firstRewardCount = 2;//第一个礼包奖励个数
    const itemHeight = 105;
    let nodes = bottom.getChildByName("nodes");
    let giftBagIds = self.TrinityGiftBagMgr.info.giftBagIds;
    let goodsIds = [];
    for (let i = 1; i < 5; i++) {
        const id = giftBagIds[i];
        goodsIds.push(id);
        let cfg = self.TrinityGiftBagMgr.getRewardById(id);
        if (cfg) {
            let btn = bottom.getChildByName("lib_btn_green_normal" + i);
            let list = cfg.itemRewards.split(",");
            //
            let rewards = [];
            for (let j = 0; j < list.length; j++) {
                const arr = list[j].split(":");
                const itemId = Number(arr[0]);
                const num = Number(arr[1]);
                rewards.push({ itemId, num });
                //创建奖励icon
                if (i < 4) {
                    const item = UIItemBuilder.createProp(itemId)[0];
                    const posY = j * itemHeight + 70;
                    item.setScale(0.85);
                    item.setPosition(btn.x + 2, posY);
                    nodes.addChild(item);
                    //
                    let num_label = cc.LabelBMFont.create("x" + num, "font/berlinsansfb_40_lightbrownstroke.fnt");
                    num_label.setScale(0.85);
                    num_label.setPosition(item.x, posY - 52);
                    nodes.addChild(num_label);
                }
            }

            btn.getChildByName("label").setString("￥" + cfg.price);

            if (i == 1) {
                firstRewardCount = list.length;
            } else if (i == 4) {
                dsct_label.setString(cfg.discountShow + "折");
                btn.getChildByName("label").setString("￥" + cfg.price + "全都要");
            }

            let buySucc = function () {
                ActivityGetRewardsPanel.show({
                    type: 1,
                    // add_model: ModuleName.TRINITY_GIFT_BAG,
                    rewardList: rewards,
                    tobagAni: true,
                    title: "normal",
                    closeCb: () => {
                        self.onClose();
                    }
                })
            }
            //
            quickBuildUIButton(btn, () => {
                if (self.isBusy) return;
                self.isBusy = true;
                self.dcData.goodsId = id;
                self.TrinityGiftBagMgr.clickBuyGoods(id, self.dcData, (buy) => {
                    if (buy) {
                        buySucc();
                    } else {
                        if (!self.TrinityGiftBagMgr.isOpen()) {
                            self.TrinityGiftBagMgr.triggerBuySucc(false);
                            self.onClose();
                            return;
                        }
                        self.isBusy = false;
                    }
                });
            })
        }
    }
    //
    if (firstRewardCount > 2) {
        const offest = (firstRewardCount - 2) * itemHeight / 2;
        top.y += offest;
        bottom.y -= offest;
        self.getChildByName("trinity_gift_bg").height += offest * 2;
    }
    //
    startCountDown(self);
    //
    let session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    let current_stage = UserManager.getInstance().getUserRef().getTopLevelId();
    const entry = self.TrinityGiftBagMgr.fromToPanel;
    self.dcData = { session, current_stage };
    if (entry == "stage_end") {
        self.dcData = JSON.parse(JSON.stringify(self.TrinityGiftBagMgr.dcData));
    }
    self.dcData.scence = ModuleName.TRINITY_GIFT_BAG;
    self.dcData.entry = entry;
    DCAssist.dc4ShowCashGoods(ModuleName.TRINITY_GIFT_BAG, entry, goodsIds, null, session, self.dcData);
}

TrinityGiftBagPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this;
    if (!self.TrinityGiftBagMgr.isOpen()) {
        let icon = self.TrinityGiftBagMgr.getSceneIcon();
        icon && icon.destroyBtn();
    }
    //
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);
}

TrinityGiftBagPanel.prototype.onCleanup = function () {
    let self = this;
    delCountDown(self);
    ResManager.release(RES);
}

function startCountDown(self) {
    delCountDown(self);

    self.countDown = CountDownCmpt.AutoRun(self.timeL, self.TrinityGiftBagMgr.info.showEndTime, () => {
        //
        self.timeL.string = "活动已结束";
        delCountDown(self);
    }, (remain, day, hour, min, sec) => {
        if (day > 0) {
            return day + "天" + hour + "小时";
        } else {
            return string.format("%02d:%02d:%02d", hour, min, sec);
        }
    });
}

function delCountDown(self) {
    if (self.countDown) {
        self.countDown.destroy();
        self.countDown = null;
    }
}

TrinityGiftBagPanel.prototype.fitScreen = function () {
    let self = this;
    const scaleY = display.height / GamePlayConfig_Design_Height;
    const scaleX = display.width / GamePlayConfig_Design_Width;
    if (scaleY / scaleX > 1) {
    } else {
        let scale = Math.min(scaleX, scaleY);
        self._scale = scale;
        self.setScale(self._scale);
    }
}

module.exports = TrinityGiftBagPanel
